import { Badge, Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import Colors from "../../../../global/Colors";

import SubMenuList from "./SubMenu/components/SubMenuList";

export default function ActionButton({ children, sx }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const link = children?.link || null;
  const subMenuList = children?.subMenuList?.() || null;
  const content = children?.content || 0;
  const navigate = useNavigate();

  const isSubMenu = () => {
    return subMenuList && subMenuList.length > 0;
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleGeneralClick = (event) => {
    if (link) {
      navigate(link);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        onClick={isSubMenu() ? handleMenuClick : handleGeneralClick}
        aria-controls={open ? "dropdown-menu" : undefined}
        aria-haspopup={"true"}
        aria-expanded={open ? "true" : undefined}
        className="m-0 p-0 text-4xl"
        sx={sx ?? {}}
      >
        <Badge
          badgeContent={parseInt(content)}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          sx={{
            "& .MuiBadge-badge": {
              color: Colors.white,
              backgroundColor: Colors.red[600],
            },
          }}
        >
          {children?.icon}
        </Badge>
      </Button>
      <SubMenuList
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
        subMenuList={subMenuList}
      />
    </>
  );
}
